module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst entityContext = (config || {}).entityContext || 'productAdditionalInformation'\nconst additionalClasses = []\n// TODO: remove import feature completely after new requestProductsAdditionalInformation feature has been completed.\n// const importGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:import', (config || {}).roleOptionScope || 'mblx')\nconst importGranted = false\nconst requestProductAdditionalInformationGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:generate', 'mblx')\nconst tooltips = config.tooltips || {}\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<section class=\"main\">\n<section class=\"top\">\n<section class=\"left\">\n<h1><%= storage.__(config.titleKey || ''); %></h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n<%\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }); %><%\nif(requestProductAdditionalInformationGranted){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'requestProductsAdditionalInformation', symbolOnly: false } }); %><%\n}\nif(importGranted){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'import', context: entityContext, symbolOnly: false, positive: true } }); %><%\n}\n%>\n</section>\n</section>\n<%\nif(tooltips.NW){\n%><%- include('../../../../base/tooltip/tooltip', { model: tooltips.NW }); %><%\n}\n%>\n<section class=\"bottom\">\n<%- helpers.renderSection('filter'); %>\n<%- helpers.renderSection('list'); %>\n</section>\n</section>\n</div>"
  , __filename = "components/templates/mblx/products/additionalInformation/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const entityContext = (config || {}).entityContext || 'productAdditionalInformation'
const additionalClasses = []
// TODO: remove import feature completely after new requestProductsAdditionalInformation feature has been completed.
// const importGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:import', (config || {}).roleOptionScope || 'mblx')
const importGranted = false
const requestProductAdditionalInformationGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:generate', 'mblx')
const tooltips = config.tooltips || {}

    ; __line = 9
    ; __append("\n<div class=\"")
    ; __line = 10
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<section class=\"main\">\n<section class=\"top\">\n<section class=\"left\">\n<h1>")
    ; __line = 14
    ; __append(escapeFn( storage.__(config.titleKey || '') ))
    ; __append("</h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n")
    ; __line = 18
    ; 

    ; __line = 19
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }) )
    ; 
if(requestProductAdditionalInformationGranted){

    ; __line = 21
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'requestProductsAdditionalInformation', symbolOnly: false } }) )
    ; 
}
if(importGranted){

    ; __line = 24
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'import', context: entityContext, symbolOnly: false, positive: true } }) )
    ; 
}

    ; __line = 26
    ; __append("\n</section>\n</section>\n")
    ; __line = 29
    ; 
if(tooltips.NW){

    ; __line = 31
    ; __append( include('../../../../base/tooltip/tooltip', { model: tooltips.NW }) )
    ; 
}

    ; __line = 33
    ; __append("\n<section class=\"bottom\">\n")
    ; __line = 35
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 36
    ; __append( helpers.renderSection('list') )
    ; __append("\n</section>\n</section>\n</div>")
    ; __line = 39
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/products/additionalInformation/controller.ejs

}